import { render } from "./PixAccountContainer.vue?vue&type=template&id=313a4350"
import script from "./PixAccountContainer.vue?vue&type=script&lang=js"
export * from "./PixAccountContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__